// Список блюд

export const data = [
    [
        {
            id: 1,
            name: 'BeshBarmak',
            price: 200,
            imageUrl: 'https://st2.depositphotos.com/1198682/45807/i/600/depositphotos_458070410-stock-photo-kazakh-traditional-dish-beshbarmak-with.jpg',
        },
    {
        id: 2,
        name: 'Manty',
        price: 200,
        imageUrl: 'https://s1.eda.ru/StaticContent/Photos/120424122748/211227223840/p_O.jpg',
    },

    {
        id: 3,
        name: 'Kuurdak',
        price: 400,
        imageUrl: 'https://zor.store/images/detailed/40/Kuurdak_po-turecki_iz_baraniny.png',
    },

    {
        id: 4,
        name: 'Olobo',
        price: 350,
        imageUrl: 'https://i.mycdn.me/i?r=AzEPZsRbOZEKgBhR0XGMT1RkhPGimuudkcpBF7sKXt4WJKaKTM5SRkZCeTgDn6uOyic',
    }, {
        id: 5,
        name: 'Soup',
        price: 290,
        imageUrl: 'https://pakistanatlas.com/wp-content/uploads/2020/09/Pakistani-Food_0106_107-DuoDo-Soup.png',
    },

    {
        id: 6, name: 'Lagman', price: 310, imageUrl: 'https://lagman.one/img/lagman.png',
    }],
    [
        {
            id: 7,
            name: 'Strawberry pie',
            price: 250,
            imageUrl: 'https://media.graphassets.com/resize=fit:clip,height:350,width:350/output=format:webp/tDr8BwFTSi74cSVtoZAW',
        },

        {
            id: 8,
            name: 'Chokolate biscuit',
            price: 150,
            imageUrl: 'https://www.moonacoffee.com/wp-content/uploads/2015/02/slider_1.png',
        }, {
        id: 9,
        name: 'Chocolate ice cream',
        price: 190,
        imageUrl: 'https://images.ctfassets.net/l5fkpck1mwg3/4iQ8pziiW1pXkpVVBbSSWN/25d2de6298e197cd9220113567ff4b6c/Dessert_Loaded_Ice_Cream.png',
    }, {
        id: 10,
        name: 'Strawberry cake',
        price: 900,
        imageUrl: 'https://az727718.vo.msecnd.net/04a723d76d5c4b8389637eb2e16b1272/images/8c404544378e4974835e818958be9b53@2x.png',
    },

        {
            id: 11,
            name: 'Macarons',
            price: 1400,
            imageUrl: 'https://dufflet.com/wp-content/uploads/2020/11/hero_cat_SMACO_aug21.png',
        },

        {
            id: 12,
            name: 'San Sebastian',
            price: 340,
            imageUrl: 'https://images.getbento.com/accounts/8e3ba4ef42a91981ef0c8c83d96b3e4a/media/images/57775RED_BERRY_OPERA_INDV._SWB.png?w=1200&fit=crop&auto=compress,format&crop=focalpoint&fp-x=0.5&fp-y=0.5',
        },
    ],
    [
        {
        id: 13,
        name: 'Margarito',
        price: 470,
        imageUrl: 'https://cicciopizza.ro/450-large_default/pizza-margherita.jpg',
    }, {
        id: 14,
        name: 'Pepperoni',
        price: 500,
        imageUrl: 'https://kurgan.muka-ris.ru/upload/iblock/0bb/0bb567f02f21fbad4c2f24d1794601d3.png',
    }, {
        id: 15,
        name: 'Italian',
        price: 535,
        imageUrl: 'https://francospizzaandpasta.co.uk/wp-content/uploads/2022/01/italian-pizzeria.png',
    }, {
        id: 16,
        name: 'Manapoli',
        price: 445,
        imageUrl: 'https://momentopizza.com.ua/wp-content/uploads/2020/05/17-copy.png',
    }, {
        id: 17,
        name: 'Homemade',
        price: 500,
        imageUrl: 'https://jow.fr/_next/image?url=https%3A%2F%2Fstatic.jow.fr%2F880x880%2Frecipes%2FnuSTxvetkb.png&w=2560&q=100',
    }, {
        id: 18,
        name: 'Hawayana',
        price: 480,
        imageUrl: 'https://tofuu.getjusto.com/orioneat-prod-resized/j5gFcQgYqneBwvkFk-1200-1200.webp',
    },],
    [
        {
        id: 19,
        name: 'Pepsi',
        price: 100,
        imageUrl: 'https://www.pepsimax.se/prod/s3fs-public/2022-12/Pepsi%20Reg%2033cl%20Sleek%20Can%20LoRes%20Web.png',
    }, {
        id: 20,
        name: 'Coca Cola',
        price: 100,
        imageUrl: 'https://www.naughtygrapett.com/wp-content/uploads/2021/09/Coca_colo_can_8oz_12391046-min.png',
    }, {
        id: 21,
        name: 'Fanta',
        price: 110,
        imageUrl: 'https://api.e-dostavka.by/UserFiles/images/catalog/Goods/2105/00012105/norm/00012105.n_1.png',
    }, {
        id: 22,
        name: 'Sprite',
        price: 140,
        imageUrl: 'https://www.shortysliquor.com.au/media/catalog/product/cache/31c831e646b0e3d5fc6a02c7bbf2f6a4/4/0/40206_2.png',
    }, {
        id: 23,
        name: '7UP',
        price: 105,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0653/8349/7942/products/7upLemon_Bubbles330ml.png?v=1670595369&width=2048',
    }, {
        id: 24,
        name: 'Schweppes',
        price: 105,
        imageUrl: 'https://winetime.md/wp-content/uploads/2022/05/schweppes_indian_250-1.png',
    }],
    [    {
        id: 25,
        name: 'Tea',
        price: 25,
        imageUrl: 'https://pngimg.com/d/tea_PNG16927.png',
    }, {
        id: 26,
        name: 'Tea Milk',
        price: 30,
        imageUrl: 'https://www.wushiland-usa.com/product/image/pics/%E7%A2%B3%E5%9F%B9%E7%83%8F%E9%BE%8D%E5%A5%B6%E8%8C%B6.png',
    }, {
        id: 27,
        name: 'Cappuccino',
        price: 120,
        imageUrl: 'https://media.istockphoto.com/id/942186500/vector/coffee-art-vector-cup-top-view-hot-cappuccino-coffee-white-mug-realistic-illustration.jpg?s=612x612&w=0&k=20&c=osx9Liukb8beGyytMiPZM_MJ-wgOU2tSfymmZWT6nVA=',
    }, {
        id: 28,
        name: 'Americano',
        price: 120,
        imageUrl: 'https://franko.su/upload/iblock/103/tw30tu5v1g6fooxafoq14i1w3802i3l9.png',
    }, {
        id: 29,
        name: 'Mocha',
        price: 190,
        imageUrl: 'https://www.starbucksathome.com/kz/sites/default/files/styles/rdp_banner_image/public/2021-06/10032021_CafeMocha_CS-min.png?itok=6Y-TdzYT',
    }, {
        id: 30,
        name: 'Latte',
        price: 150,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0319/0764/3436/products/vanilla-caffe-latte.png?v=1597269391',
    },
    ],
    [
        {
        id: 31,
        name: 'Baklava',
        price: 90,
        imageUrl: 'https://play-lh.googleusercontent.com/FD-_DXtKoh-ROND3H1BzF5lpRWw7r4JAuAsJc7Rq-l11mz4wn83kr-ZZ2h48mvHW-DM',
    }, {
        id: 32,
        name: 'Shawarma',
        price: 140,
        imageUrl: 'https://www.shawarmabarlow.com/assets/images/Beef-Donair-1000.png',
    }, {
        id: 33,
        name: 'Shashlik',
        price: 370,
        imageUrl: 'https://indelika.com/wp-content/uploads/2020/10/recipe-4.png',
    }, {
        id: 34,
        name: 'Kofta',
        price: 250,
        imageUrl: 'https://static.wixstatic.com/media/d32071_44fa4578b54449f6a285289d9a8a6811~mv2.png/v1/fill/w_611,h_408,al_c/d32071_44fa4578b54449f6a285289d9a8a6811~mv2.png',
    }, {
        id: 35,
        name: 'Hummus',
        price: 225,
        imageUrl: 'https://food.fnr.sndimg.com/content/dam/images/food/fullset/2013/12/19/0/FNM_010114-Homemade-Hummus-Recipe_s4x3.jpg.rend.hgtvcom.616.462.suffix/1389218464364.jpeg',
    }, {
        id: 36,
        name: 'Kanafeh',
        price: 220,
        imageUrl: 'https://knafehhouse.com/wp-content/uploads/2020/07/Knafeh-FG1.png',
    },],
    [
        {
        id: 37, imageUrl: 'https://mbank.kg/media/logo/Logo_4EIfhYF.svg',
    }, {
        id: 38,
        imageUrl: 'data:image/png;base64,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',
    }, {
        id: 39, imageUrl: "https://logowik.com/content/uploads/images/visa-payment-card1873.jpg"
    },],
]

console.log(data)


export const visa = [
    {
        id: 39,
        imageUrl: "https://logowik.com/content/uploads/images/visa-payment-card1873.jpg"
    },
];
